import { Space } from "antd";
import { useEffect, useState } from "react";
import DefaultFormParserLayout from "../../../components/Layouts/default-form-parser-layout";
import Button from "../../../components/UI/Button";
import SelectInput from "../../../components/UI/SelectInput";
import SmartSearch from "../../../components/UI/SmartSearch";
import { useLoading } from "../../../context/LoadingProvider/useLoading";
import useSmartSearchParams from "../../../hooks/useSmartSearchParams";
import { getReport } from "../../../services/reports";
import { Output } from "../../../services/types";
import endpoints from "../../../utils/endpoints";
import { removeEmpty } from "../../../utils/objectUtils";
import { createIdFromSmartSearchParams } from "../../../utils/smartSearch";

const aliasOptions = [
  { name: "GAME and POS", value: "GAME and POS" },
  { name: "GAME", value: "GAME" },
  { name: "POS", value: "POS" },
];

function POSBundleStatus() {
  const loading = useLoading();

  const [params, setParams] = useSmartSearchParams();
  const [search, setSearch] = useState("");
  const [validSearch, setValidSearch] = useState(false);
  const [report, setReport] = useState("");
  const [alias, setAlias] = useState(aliasOptions[0].value);

  const refreshReport = async (output: Output = Output.HTML) => {
    loading.addLoading();

    const requestParams: Record<string, any> = {
      typeFilterData: alias,
      output,
      name:"POS Bundle Status",
    };

    if (params.id) {
      const id = createIdFromSmartSearchParams(params);
      requestParams[id] = params.id;
    }

    const res = await getReport(
      removeEmpty(requestParams),
      endpoints.getPOSBundleStatusReport,
      output,
    );
    if (output === Output.HTML) {
      setReport(res);
    }

    loading.removeLoading();
  };

  return (
    <DefaultFormParserLayout html={report}>
      <Space direction="horizontal" size="small" wrap>
        <SmartSearch
          label="Smart Search"
          searchBy={["distributor", "charity", "location"]}
          onChange={(e: string) => setSearch(e)}
          status="active"
          value={search}
          validOnEmpty
          onValidSearch={setValidSearch}
          onObjValueChange={(e: any) => setParams({ ...params, ...e })}
          autoFocus
        />
        <SelectInput
          label="Alias"
          options={aliasOptions}
          value={alias}
          onSelectChange={(e) => setAlias(e?.value ? e.value : e)}
        />
        <Button
          type="primary"
          onClick={() => refreshReport()}
          disabled={!validSearch}
        >
          Refresh
        </Button>
        <Button
          type="primary"
          onClick={() => refreshReport(Output.CSV)}
          disabled={!validSearch}
        >
          Save as CSV
        </Button>
        <Button
          type="primary"
          onClick={() => refreshReport(Output.PDF)}
          disabled={!validSearch}
        >
          Save as PDF
        </Button>
      </Space>
    </DefaultFormParserLayout>
  );
}

export default POSBundleStatus;
